import {OnFailure, OnSuccess, OnSuccessData} from "../../../store/action/actionHelpers";
import Appointment from "../../../model/appointment/Appointment";
import {createAppointment, updateAppointment} from "../../../store/action/appointment/appointment";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import * as React from "react";
import {none, option, Option} from "ts-option";
import DateTimePicker from "../../../hiberUiKit/src/molecules/DateTimePicker/DateTimePicker";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import Toast from "../../helper/Toast";
import AppointmentStatus, {AppointmentStatusEnum} from "../../../model/appointment/AppointmentStatus";
import {RootState} from "../../../store/reducer/root/RootState";
import DateUtils from "../../../utils/DateUtils";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import AppointmentType from "../../../model/appointment/AppointmentType";
import AppointmentSalesEngineerDropdown from "../v4/AppointmentSalesEngineerDropdown";
import AppointmentUtils, {IAppointmentDuration} from "../../../utils/AppointmentUtils";
import {isDefined} from "../../../utils/Utils";
import moment = require("moment");
import _ = require("underscore");

interface IProps {
	/**
	 * Lead id.
	 */
	leadId: string;
	/**
	 * Lead partner brand id.
	 */
	leadPartnerBrandId: Option<string>;
	/**
	 * Appointment to edit.
	 */
	appointmentToEdit?: Option<Appointment>
	/**
	 * Appointment edit success callback.
	 */
	onAppointmentEditSuccess?: () => void;
}

interface DispatchProps {
	/**
	 * Update appointment
	 * @param {string} leadId
	 * @param {Appointment} appointment
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateAppointment: (leadId: string, appointment: Appointment, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Create appointment
	 * @param {string} leadId
	 * @param {Appointment} appointment
	 * @param {OnSuccessData<Appointment>} onSuccess
	 * @param {OnFailure} onFailure
	 */
	createAppointment: (leadId: string,
		appointment: Appointment,
		onSuccess: OnSuccessData<Appointment>,
		onFailure: OnFailure) => void;
}

interface IReduxProps {
	appointments: Appointment[],
	appointmentTypes: AppointmentType[]
}

interface IState {
	/**
	 * Indicating if request to server is in progress.
	 */
	isLoading: boolean;
	/**
	 * Appointment datetime.
	 */
	appointmentDateTime: moment.Moment | null;
	/**
	 * Appointment type
	 */
	appointmentType: Option<AppointmentType>;
	/**
	 * Sales engineer assigned to appointment.
	 */
	appointmentSalesEngineerId: string | null;
	/**
	 * Appointment duration in minutes
	 */
	appointmentDuration: Option<number>
}

type Props = IProps & DispatchProps & IReduxProps;

class AppointmentTab extends React.Component<Props, IState> {

	durations = AppointmentUtils.getAppointmentDurations();

	constructor(props: Props) {
		super(props);
		this.state = {
			isLoading: false,
			appointmentDateTime: null,
			appointmentType: none,
			appointmentSalesEngineerId: null,
			appointmentDuration: none
		};
		this.onDateTimeChange = this.onDateTimeChange.bind(this);
		this.onSalesEngineerChange = this.onSalesEngineerChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.appointmentDataInvalid = this.appointmentDataInvalid.bind(this);
		this.isDurationItemDisable = this.isDurationItemDisable.bind(this);
	}

	componentDidMount() {
		if (this.props.appointmentToEdit.isDefined) {
			this.setState({
				appointmentDateTime: this.props.appointmentToEdit.map(a => a.dateTime).orNull,
				appointmentType: this.props.appointmentToEdit.flatMap(ate => ate.type),
				appointmentSalesEngineerId: this.props.appointmentToEdit.flatMap(a => a.assigneeId).orNull,
				appointmentDuration: this.props.appointmentToEdit.map(a => a.duration)
			});
		}
	}

	componentWillReceiveProps(nextProps: Props) {
		if (nextProps.appointmentToEdit.isDefined) {
			this.setState({
				appointmentDateTime: nextProps.appointmentToEdit.map(a => a.dateTime).orNull,
				appointmentType: nextProps.appointmentToEdit.flatMap(ate => ate.type),
				appointmentSalesEngineerId: nextProps.appointmentToEdit.flatMap(a => a.assigneeId).orNull,
				appointmentDuration:nextProps.appointmentToEdit.map(a => a.duration)
			});
		}
	}

	render() {

		const disabledDateTimes = this.getDisabledDateTimes(this.props.appointments);
		const disabledDateTimesGroupedByDay = _.groupBy(disabledDateTimes,
			(item) => moment(item).startOf("day").format(DateUtils.DATE_FORMAT));
		const excludeDates: moment.Moment[] = [];
		const now = moment();
		Object.keys(disabledDateTimesGroupedByDay).forEach((key) => {
			//65 = 4*11+1 -> count of items with time in list [6:00, 6:15 ... 22:00]/
			if (disabledDateTimesGroupedByDay[key].length == 65) {
				return excludeDates.push(moment(key, DateUtils.DATE_FORMAT))
			}
			if (this.props.appointmentToEdit.isEmpty && moment(key, DateUtils.DATE_FORMAT).isSame(now, "day")) {
				const endTime = moment(now, "HH:mm").diff(moment().startOf("day"), "minutes");
				const timesInPast = [];
				for (let t = 6 * 60; t < endTime; t += 15) {
					const tmp = moment().startOf("day").add(t, "m");
					if (!disabledDateTimesGroupedByDay[key].filter(item => item.isSame(tmp, "minutes")).length)
						timesInPast.push(tmp);
				}
				if (timesInPast.length + disabledDateTimesGroupedByDay[key].length == 65) {
					return excludeDates.push(moment(key, DateUtils.DATE_FORMAT))
				}
			}
		});

		return (
			<div className={"c-appointment-tab"}>
				<div className={"c-appointment-tab_actions"}>
					<DateTimePicker initialDateTime={this.state.appointmentDateTime}
									onDateTimeChange={this.onDateTimeChange}
									disabledDateTimes={disabledDateTimes}
									excludeDates={excludeDates}/>
					<div className={"c-duration-dropdown"}>
						<DropDown placeholder={"Duration"}
								  items={this.durations}
								  itemToId={(item: IAppointmentDuration) => `${item.minutes}`}
								  itemToLabel={(item: IAppointmentDuration) => item.displayValue}
								  selectedItemId={this.state.appointmentDuration.map(d => `${d}`).orNull}
								  onSelect={(item: IAppointmentDuration) => this.setState(
									  {appointmentDuration: option(item.minutes)})}
								  disabled={!isDefined(this.state.appointmentDateTime)}
								  itemDisabled={this.isDurationItemDisable}/>
					</div>
					<div className={"c-appointment-type-dropdown"}>
						<DropDown placeholder={"Appointment type"}
								  items={this.props.appointmentTypes}
								  itemToId={(item: AppointmentType) => item.id}
								  itemToLabel={(item: AppointmentType) => item.getDisplayName()}
								  selectedItemId={this.state.appointmentType.map(at => at.id).orNull}
								  onSelect={(item: AppointmentType) => this.setState({appointmentType: option(item)})}
								  clearable
								  onClearClick={() => this.setState({appointmentType: none})}/>
					</div>
					<div className={"c-se-dropdown"}>
						<AppointmentSalesEngineerDropdown selectedSalesEngineerId={option(this.state.appointmentSalesEngineerId)}
														  onChange={this.onSalesEngineerChange}
														  placeholder={"Select sales engineer"}
														  leadPartnerBrandId={this.props.leadPartnerBrandId}/>
					</div>
					<ButtonPrimary label={this.props.appointmentToEdit.isDefined ? "Update Appointment" : "Add Appointment"}
								   onClick={this.onSubmit}
								   disabled={this.appointmentDataInvalid()}/>
				</div>
			</div>
		);
	}

	private isDurationItemDisable(duration: IAppointmentDuration, appointmentDateTime = this.state.appointmentDateTime): boolean {
		const isNextDay = AppointmentUtils.isNextDay(option(appointmentDateTime), duration.minutes);
		const isCollisions = AppointmentUtils.isCollisionWithAppointment(duration.minutes, appointmentDateTime,
			this.props.appointments);
		return isNextDay || isCollisions;
	};

	private onDateTimeChange(dateTime: moment.Moment) {
		if (!dateTime.isSame(this.state.appointmentDateTime, "minute")) {
			const twoHour = this.durations.filter(i => i.minutes == 120)[0];
			// if selected duration is available then nothing change otherwise
			// if 2 hours duration available then select otherwise
			// leave empty
			const appointmentDuration = this.state.appointmentDuration.flatMap(d =>
				this.isDurationItemDisable(this.durations.filter(i => i.minutes == d)[0], dateTime) ? none : option(d)
			).orElse(() => this.isDurationItemDisable(twoHour, dateTime) ? none : option(twoHour.minutes));

			this.setState({appointmentDateTime: dateTime, appointmentDuration});
		}
	}

	private onSalesEngineerChange(seId: string) {
		this.setState({appointmentSalesEngineerId: seId});
	}

	private onSubmit() {
		this.setState({isLoading: true});
		if (this.props.appointmentToEdit.isDefined) {
			const updatedDateTime = this.state.appointmentDateTime;
			const updatedAppointmentType = this.state.appointmentType;
			const updatedSalesEngineerId = this.state.appointmentSalesEngineerId;
			const updatedDuration = this.state.appointmentDuration.orNull;
			this.props.updateAppointment(this.props.leadId, this.props.appointmentToEdit.get.copy({
					dateTime: updatedDateTime,
					duration: updatedDuration,
					status: AppointmentStatus.fromString(AppointmentStatusEnum.Unconfirmed),
					type: updatedAppointmentType,
					assigneeId: option(updatedSalesEngineerId)
				}),
				() => {
					Toast.success("Appointment created", "Appointment updated");
					this.setState(
						{isLoading: false, appointmentDateTime: null, appointmentType: none, appointmentSalesEngineerId: null});
					this.props.onAppointmentEditSuccess();
				},
				() => {
					this.onFailure("Update Appointment")
				})
		}
		else {
			this.props.createAppointment(this.props.leadId,
				Appointment.create(
					this.state.appointmentDateTime,
					this.state.appointmentType,
					option(this.state.appointmentSalesEngineerId),
					this.state.appointmentDuration.orNull
				),
				() => {
					Toast.success("Appointment created", "Appointment created");
					this.setState({isLoading: false, appointmentDateTime: null, appointmentType: none});
					this.props.onAppointmentEditSuccess();
				},
				() => {
					this.onFailure("Create Appointment")
				})
		}
	}

	onFailure(title: string) {
		this.setState({isLoading: false});
		Toast.error("Sorry, something went wrong. Try again later.", title)
	}

	private appointmentDataInvalid() {
		return this.state.isLoading
			|| (this.state.appointmentDateTime ? !this.state.appointmentDateTime.isValid() : true)
			|| this.state.appointmentDuration.isEmpty;
	}

	/**
	 * Get disabled date times
	 * Example: when adt == 14:00 then disabled <12:15 - 15:45>
	 * @param {Appointment[]} appointments
	 * @returns {moment.Moment[]}
	 */
	private getDisabledDateTimes(appointments: Appointment[]): moment.Moment[] {
		const dateTimes: moment.Moment[] = [];

		appointments.filter(a => this.props.appointmentToEdit.map(appToEdit => appToEdit.id != a.id).getOrElse(true))
			.forEach(appointment => {
				const adt = appointment.dateTime;
				const startTime = moment(moment(adt).add(-(this.durations[0].minutes - 15), "m"), "HH:mm").diff(
					moment(adt).startOf("day"),
					"minutes");
				const endTime = moment(moment(adt).add(appointment.duration, "m"), "HH:mm").diff(moment(adt).startOf("day"),
					"minutes");
				for (let t = startTime; t < endTime; t += 15) {
					const tmp = moment(adt).startOf("day").add(t, "m");
					if (t >= 6 * 60 && t <= 22 * 60 &&
						!dateTimes.filter(item => item.isSame(tmp, "minutes")).length)
						dateTimes.push(tmp);
				}
			});

		return dateTimes
	}
}

function mapStateToProps(state: RootState, props: IProps) {
	const appointments = state.appointment.appointments[props.leadId] || [];
	return ({appointments, appointmentTypes: state.appointment.appointmentTypes.getOrElse([])})
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateAppointment: (leadId: string, appointment: Appointment, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			updateAppointment(leadId, appointment, onSuccess, onFailure)),
		createAppointment: (leadId: string,
			appointment: Appointment,
			onSuccess: OnSuccessData<Appointment>,
			onFailure: OnFailure) => dispatch(createAppointment(leadId, appointment, onSuccess, onFailure))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentTab)